import { beCloudToCloud } from '@cast/shared-types';

import { NodeWithDependencies } from 'features/cluster/nodes/types';

import { getNodeRegion, isEdgeNode } from 'utils/node';
import { Detail } from './Detail';

import { Section } from './Section';
import { CspIcon } from '@cast/shared-csp-icons-ui';

import { Typography, Stack } from '@cast/design-system';

type Props = {
  node: NodeWithDependencies;
};

const TITLE = 'Cloud';

export const CloudSection = ({ node }: Props) => {
  const region = getNodeRegion(node);

  return (
    <Section title={TITLE} testId="node-details-cloud-section">
      <Detail
        title="Cloud:"
        detail={
          <Stack direction="row" gap={4}>
            <CspIcon csp={beCloudToCloud(node.cloud)} size={16} />
            <Typography variant="P12R">{node.cloud?.toUpperCase()}</Typography>
          </Stack>
        }
        testId="node-details-cloud"
      />
      <Detail
        title="Availability zone:"
        detail={node.zone}
        showCopy
        copyValue={node.zone}
        testId="node-details-availability-zone"
      />
      <Detail
        title="Region:"
        detail={`${region}${isEdgeNode(node) ? ' (Extended)' : ''}`}
        showCopy
        copyValue={region}
        testId="node-details-region"
      />
      <Detail
        title="IP address:"
        detail={node.network?.publicIp}
        showCopy
        copyValue={node.network?.publicIp}
        testId="node-details-ip-address"
      />
    </Section>
  );
};

const CloudSectionSkeleton = () => {
  return (
    <Section title={TITLE}>
      <Detail.Skeleton />
      <Detail.Skeleton />
      <Detail.Skeleton />
    </Section>
  );
};

CloudSection.Skeleton = CloudSectionSkeleton;
